import format from 'date-fns/format';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import ViewIcon from '@material-ui/icons/Visibility';
import DataTable from 'components/CncUI/DataTable';

const useStyles = makeStyles(({ palette }) => ({
  link: {
    color: palette.cncUI.primary.gray['+0'],
    cursor: 'pointer',
    marginLeft: 8,
  },
}));

const List = ({ items, setDownloader, setViewer }) => {
  const classes = useStyles();
  const dateFormat = ({ createdAt }) =>
    format(parseInt(createdAt, 10), 'MMMM do, yyyy');
  const actions = w4 => (
    <Grid container spacing={2} justify="flex-end" alignItems="center">
      <Grid item>
        {w4.lastLevelHistoryProcessed ? (
          <>
            <ViewIcon
              id={`View-${w4.id}`}
              className={classes.link}
              onClick={() => setViewer(w4.documentId)}
            />
            <DownloadIcon
              id={`Download-${w4.id}`}
              className={classes.link}
              onClick={() => setDownloader(w4.documentId)}
            />
          </>
        ) : (
          <CircularProgress
            size={20}
            id={`Processing-${w4.id}`}
            className={classes.link}
          />
        )}
      </Grid>
    </Grid>
  );

  const columns = [
    {
      field: 'name',
      label: 'File Name',
      cellProps: { style: { width: '40%' } },
    },
    {
      field: 'createdAt',
      label: 'Date Uploaded',
      value: dateFormat,
      cellProps: { style: { width: '40%' } },
    },
    {
      field: 'actions',
      label: ' ',
      sortable: false,
      value: actions,
      cellProps: { style: { width: '10%' } },
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataTable
          transparent
          columns={columns}
          data={items}
          sort="createdAt"
          order="desc"
        />
      </Grid>
    </Grid>
  );
};

export default List;
